module.exports = __webpack_public_path__ + "img/2-楼盘小程序-03.20c004b4.png";